import {Component, OnInit} from '@angular/core';
import {TimeTrackerService} from '../time-tracker-service.service';
import {Device} from '../../models/device';
import {BsModalRef} from 'ngx-bootstrap/modal/bs-modal-ref.service';
import {BsModalService} from 'ngx-bootstrap';
import {DeviceModalComponent} from '../modals/device-modal';

@Component({
    selector: 'app-device-register',
    templateUrl: './device-register.component.html',
    styleUrls: ['./device-register.component.css']
})

export class DeviceRegisterComponent implements OnInit {
    bsModalRef: BsModalRef;
    users: Array<any> = [];
    searchInputFilter = '';
    PHONE = Device.PHONE;
    TABLET = Device.TABLET;

    constructor(public tts: TimeTrackerService, public bsModalService: BsModalService) {
        tts.getUsersFromCompany('nvd', users => this.users = users);
    }

    ngOnInit() {
    }

    public editDevice(device: Device) {
        this.bsModalRef = this.bsModalService.show(DeviceModalComponent);
        this.bsModalRef.content.title = 'Register Device';
        this.bsModalRef.content.editMode = true;
        this.bsModalRef.content.newRegister = true;
        this.bsModalRef.content.setDevice(device);
    }

    public registerDevice(userId) {
        const device = new Device();
        device.id = userId;
        device.userId = userId;
        device.isCompanyDevice = false;
        device.name = Device.PHONE;
        device.mac = '';

        // this.bsModalRef = this.bsModalService.show(DeviceModalComponent);
        // this.bsModalRef.content.title = 'Register Device';
        // this.bsModalRef.content.editMode = true;
        // this.bsModalRef.content.newRegister = true;
        // this.bsModalRef.content.setDevice(device);


        //this.bsModalRef.content. = 'Register Device';

        this.tts.registerUserDevice(userId, device, function () {
            console.log('success save register device');
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/device-register/device-register.component.ts